// src/services/api.js
import axios from "axios";
import config from "@/config";

const api = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para agregar el token JWT a las solicitudes
api.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
// Opcional: Interceptor para manejar errores de respuesta (por ejemplo, 401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Paso adicional: No procesar errores si la ruta es /login (o /api/v1/login)
    const isLoginPath = error.config.url.includes('/login');

    if (error.response && error.response.status === 401) {
      const msg = error.response.data?.message || "";

      // Si es un error 401 de /login y es un mensaje controlado, simplemente rechazamos la promesa
      if (isLoginPath && (msg === "Contraseña expirada" || msg === "Primer acceso")) {
         return Promise.reject(error); // Permite que el catch del componente maneje la alerta
      }

      // Solo redirige si NO es un mensaje controlado por el login
      if (msg !== "Contraseña expirada" && msg !== "Primer acceso") {
        console.error("Error 401: Acceso no autorizado. Redirigiendo al login...");
        window.sessionStorage.removeItem("token");
        // Utilizamos window.location.href para forzar la recarga y salir de la app.
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
*/

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const msg = error.response.data?.message || "";
      const isLoginPath = error.config.url.includes('/login');

      // ⚠️ REDIRECCIÓN SOLO si el error 401 NO es en la ruta de login y NO tiene un mensaje controlado
      if (!isLoginPath && msg !== "Contraseña expirada" && msg !== "Primer acceso") {
        console.error("Error 401: Sesión expirada. Redirigiendo a login...");
        window.sessionStorage.removeItem("token");
        // Utilizamos window.location.href para forzar la recarga y salir de la app.
        window.location.href = "/login";
      }
    }
    // Devolvemos la promesa de rechazo para que el bloque 'catch' del componente se ejecute
    return Promise.reject(error);
  }
);

export default api;